module.exports = __webpack_public_path__ + "assets/logo.66c37df9202bb22efab7d285719167e1.png";


//////////////////
// WEBPACK FOOTER
// ./assets/logo.png
// module id = 215
// module chunks = 0